export default __webpack_public_path__ + "static/media/myblog.ed2f97db.png";